var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":3}},[_c('YearsComponent',{on:{"change":_vm.onYearSelected}})],1),_c('el-col',{attrs:{"span":3}},[_c('AsignedThecnicians',{on:{"ThecnicianChaged":_vm.onThecnicianChange}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }